import React from 'react';
import { displayMasterItem, displayDropDownItem } from '../util'
import Images from '../../../config/images'
import { Grid, Button, Form, Icon, Image, Loader} from 'semantic-ui-react'
import DateInputField from '../../../commonComponents/DateField'
import { packagingQualifiers, /*govAgencyCodesDRU,*/ lotNumbers } from '../util/constants'
import { DropDown } from '../../../commonComponents/dropDownCommon'
import InputField from '../../../commonComponents/Input'
import {  disclaimCheckboxdisabledxf } from '../../../util';
import CustomCheckbox from '../../formComponents/checkBox'
import flatten from 'lodash/flatten'

import { savePGAItemField } from '../../api/setFormData'
import { CPSC_INTENDED_USE_CODE_OPTIONS } from './CPSC_CPS/util'

export function paramyToDisclaimCodes(hsDataDtl_paramy,formType){
  let disclaimCodes = [];
  for(let deet of (hsDataDtl_paramy?.pgaMetadata?.tarriffPgaDetails || [])){
    if(!deet)continue;
    for(let program of (deet.programDetails || [])){
      if(!program)continue;
      if(program.formType == formType)
        disclaimCodes=program.disclaimCodes || [];
    }
  }
  return disclaimCodes;
}

export const disclaimReasonsPGAReasons = {
  A: "Product is not regulated by this agency",
  B: "Data is not required per agency guidance",
  C: "Data filed through other agency means",
  D: "Data filed through paper",
  E: "Product does not contain fish or wildlife, including live, dead, parts or products thereof, except as specifically exempted from declaration requirements",
}
const DisclaimCodes = ({
  // type,
  // updateField,
  // saveField,
  // title,
  // values,
  // hasContact,
  // doesntHaveEntity,
  lineItemIndex,
  merchandiseId,
  pgaValues_xx,
  // identifierLabel = 'NAME',
  formType,
  pgaGuid,
  // errorMsg,
  validateField,
  // entityIdTypes,
  // containerList,
  updatePGAField,
  // saveRepeatedField,
  formDisabled,
  hsDataDtl_paramy,
  // addRepeatedItem,
  // lcpoIssuerList,
  // uomList,
  // lpcoTypeList,
  // dateQualifierList,
  externalCheckbox,
  // showAddButton,
  // countryList,
  // allowDeleteAll,
  clearErrors,
  pgaIsCompletedByGuid,
  clearPGAFlag,
  allVoluntaryPGAs,
  voluntary_Baz,
  isDisclaimSection,
  parentThis,
  FIELD_META = {},
  savePGAField,
  errorMsg = {},
  launchFrom,
}) => {
  
  let disclaimCodes = paramyToDisclaimCodes(hsDataDtl_paramy,formType);
  for(let deet of (hsDataDtl_paramy?.pgaMetadata?.tarriffPgaDetails || [])){
    if(!deet)continue;
    for(let program of (deet.programDetails || [])){
      if(!program)continue;
      if(program.formType == formType)
        disclaimCodes=program.disclaimCodes || [];
    }
  }
  const isCpsc = formType === 'CPSC'
  if (!disclaimCodes?.length && voluntary_Baz) {
    disclaimCodes = flatten((allVoluntaryPGAs || []).map(a => a?.programDetails || []))
      .find(p => p?.formType === formType && p?.disclaimCodes?.length)
      ?.disclaimCodes || []
  }
  const disclaimBoxx =  <CustomCheckbox
    id={`${formType}-disclaim-${merchandiseId}`}
    className='electronic-cert-text'
    label='Disclaim ?'
    value={Boolean(pgaValues_xx?.disclaimFlag?.value === 'Y')}
    disabled={Boolean(formDisabled) || (disclaimCheckboxdisabledxf(formType,hsDataDtl_paramy, pgaValues_xx)  && !voluntary_Baz) || isDisclaimSection}
    update={value => {
      let flagValue = value ? 'Y' : 'N';
      let disclaimCodeUsed = pgaValues_xx?.disclaimCode?.value || 'A'
      if (isCpsc && flagValue === 'Y') {
        disclaimCodeUsed = ''
      }
      validateField(pgaValues_xx.disclaimFlag, `${formType}-${pgaValues_xx.disclaimFlag.id}`)

      
      if(pgaIsCompletedByGuid && clearPGAFlag){
          clearPGAFlag();
      }
      updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimFlag', flagValue)
      updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimCode', disclaimCodeUsed);
      pgaValues_xx.disclaimCode.value =  disclaimCodeUsed;
      pgaValues_xx.disclaimFlag.value =  flagValue;
      const saveItems = [pgaValues_xx.disclaimCode,pgaValues_xx.disclaimFlag]
      if (isCpsc && flagValue === 'N' && pgaValues_xx.intendedUseCode) {
        updatePGAField(pgaGuid, formType, merchandiseId, 'intendedUseCode', '')
        pgaValues_xx.intendedUseCode.value = ''
        saveItems.push(pgaValues_xx.intendedUseCode)
      }
      if(clearErrors){clearErrors()}
      if(parentThis){
        parentThis.setState({pgaIsSaving:true});
      }
      if(launchFrom !== 'PRODUCT_HISTORY'){ //don't save in product history
      savePGAItemField(pgaGuid, saveItems, merchandiseId, formType).then(response=>{
        if(parentThis){
            parentThis.setState({pgaIsSaving:false});
          }
        });
      }
    }}
  />;
if (!disclaimCodes?.length)
  if( pgaValues_xx?.disclaimFlag?.value == "Y"){
    return <>
    {disclaimBoxx}
    <span style={{color:'red'}}><br/>Warning: no disclaim codes for this PGA. You must provide the requested information.<br/></span>
  </>} else{
    return <></>;

  }
;
if (!formDisabled) {
  const skipAutoPickDisclaimCode =
    isCpsc && pgaValues_xx.disclaimFlag?.value === 'Y'
  if(
    !skipAutoPickDisclaimCode &&
    !window["setGuid"+pgaGuid] &&
    (!pgaValues_xx?.disclaimCode?.value || !(disclaimCodes || []).includes(pgaValues_xx.disclaimCode.value))
  ){
    window["setGuid"+pgaGuid]=true;
    updatePGAField(pgaGuid, formType,merchandiseId, 'disclaimCode', disclaimCodes[0]);
    pgaValues_xx.disclaimCode.value = disclaimCodes[0];
    if(launchFrom !== 'PRODUCT_HISTORY'){ //don't save in product history
      savePGAItemField(pgaGuid, [pgaValues_xx.disclaimCode,pgaValues_xx.disclaimFlag], merchandiseId, formType)
    }
    
  }
}
  const cpscDisclaimBlocksCodes =
    isCpsc &&
    pgaValues_xx.disclaimFlag?.value === 'Y' &&
    !String(pgaValues_xx?.intendedUseCode?.value || '').trim()
 return (
  <React.Fragment>
     {!externalCheckbox && disclaimBoxx}
    {pgaValues_xx?.disclaimFlag?.value === 'Y'  && <>{/*start disclaim section*/}
            {(pgaValues_xx?.commercialDesc ||
              (isCpsc && pgaValues_xx.disclaimFlag?.value === 'Y' && savePGAField)) && (
              <Form.Group className='merged-row'>
                {pgaValues_xx?.commercialDesc && (
                  <InputField
                    id={`${formType}-${pgaValues_xx.commercialDesc.id}`}
                    label='COMMERCIAL DESCRIPTION'
                    width={8}
                    value={pgaValues_xx.commercialDesc.value}
                    // errors={this.state.errorMsg[`${formType}-${pgaValues_xx.commercialDesc.id}`]}
                    onChange={(value) => {
                      updatePGAField(pgaGuid, formType, merchandiseId, pgaValues_xx.commercialDesc.key, value)
                    }}
                    onBlur={() => {
                      // let error = this.validateField(pgaValues_xx.commercialDesc, `${formType}-${pgaValues_xx.commercialDesc.id}`);
                      savePGAField(pgaGuid, formType, merchandiseId, lineItemIndex, pgaValues_xx.commercialDesc.key)
                    }}
                    {...FIELD_META}
                  />
                )}
                {isCpsc &&
                  pgaValues_xx.disclaimFlag?.value === 'Y' &&
                  savePGAField && (
                    <DropDown
                      id={`${formType}-${pgaValues_xx.intendedUseCode?.id}`}
                      label="INTENDED USE CODE *"
                      className="field-bg dropdown100"
                      width={8}
                      isLabel={false}
                      text={displayDropDownItem(
                        pgaValues_xx.intendedUseCode?.value,
                        CPSC_INTENDED_USE_CODE_OPTIONS
                      )}
                      data={CPSC_INTENDED_USE_CODE_OPTIONS}
                      errors={errorMsg[`${formType}-${pgaValues_xx.intendedUseCode?.id}`]}
                      onChange={(value) => {
                        if (pgaIsCompletedByGuid && clearPGAFlag) clearPGAFlag()
                        updatePGAField(
                          pgaGuid,
                          formType,
                          merchandiseId,
                          pgaValues_xx.intendedUseCode.key,
                          value
                        )
                        validateField(
                          { ...pgaValues_xx.intendedUseCode, isOptional: 'N' },
                          `${formType}-${pgaValues_xx.intendedUseCode?.id}`
                        )
                        savePGAField(
                          pgaGuid,
                          formType,
                          merchandiseId,
                          lineItemIndex,
                          pgaValues_xx.intendedUseCode.key
                        )
                      }}
                      {...FIELD_META}
                    />
                  )}
              </Form.Group>
            )}
            <div className='tsca-disclaimer-descr'>
              <p>Valid Codes are: </p>
            </div>
            <Form.Group className='merged-row'>
              {["A","B","C","D","E"].map(oneCode=><React.Fragment key={oneCode+"1234"}>
              {disclaimCodes.indexOf(oneCode)>=0 &&
                <Grid.Column width={4} className='tsca-code-column' style={{width:'50%'}}>
                  <div
                    className={
                      pgaValues_xx.disclaimCode.value === oneCode
                        ? 'buttons-tsca selected'
                        : 'buttons-tsca'
                    }
                    style={
                      cpscDisclaimBlocksCodes
                        ? { opacity: 0.45, pointerEvents: 'none', cursor: 'not-allowed' }
                        : undefined
                    }
                    onClick={() => {
                      if (!formDisabled) {
                        if (cpscDisclaimBlocksCodes) return
                        updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimFlag', 'Y')
                        updatePGAField(pgaGuid, formType, merchandiseId, 'disclaimCode', oneCode);
                        pgaValues_xx.disclaimCode.value =  oneCode;
                        pgaValues_xx.disclaimFlag.value =  'Y';
                        if(launchFrom !== 'PRODUCT_HISTORY'){ //don't save in product history  
                          savePGAItemField(pgaGuid, [pgaValues_xx.disclaimCode,pgaValues_xx.disclaimFlag], merchandiseId, formType)
                        }
                      }
                    }}
                  >
                    <div className='code-letter'>{oneCode}</div>
                    <div className='code-description'>
                       {disclaimReasonsPGAReasons[oneCode]}
                      </div>
                  </div>
                </Grid.Column>
              }
              </React.Fragment>)}
            </Form.Group>
            <br/>
            <br/>
            {disclaimCodes?.length && pgaValues_xx.disclaimCode.value? 
             <span>
                Selected Disclaim Code: <b>{pgaValues_xx.disclaimCode.value}</b>
              </span>:
              <span style={{color:"red"}}>
                  {cpscDisclaimBlocksCodes
                    ? 'Select an Intended Use Code first, then choose disclaim code A or B.'
                    : 'Make sure to select a disclaim code!'}
              </span>}
            <br/>
            {/*end disclaim section*/}</>}
          </React.Fragment>
 )}

export default DisclaimCodes;